import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { AIButtonContainedDark } from '../../../AIButton'
import Button, { BUTTON_HEIGHT_32, ButtonType } from '../../../Button'
import Text from '../../../Text'
import { GRETA_PROJECT_NAME_MAX_LENGTH } from '../../GretaAIChat.constants'
import {
  getIsGretaAIChatNameFormValid,
  GretaAIChatNameField,
} from '../../GretaAIChatNameField'

import {
  QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_CANCEL,
  QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_INPUT,
  QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_SUBMIT,
} from './GretaAIChatNewProjectForm.constants'

import * as styles from './GretaAIChatNewProjectForm.module.css'

function GretaAIChatNewProjectForm({ validationSchema, onCancel }) {
  const { t } = useTranslation()

  const { isSubmitting, values } = useFormikContext()

  const isSubmitDisabled = !getIsGretaAIChatNameFormValid({
    validationSchema,
    values,
  })

  return (
    <div className={styles.form}>
      <div className={styles.header}>
        <Text className={styles.title}>{t('Greta.NewProjectKey')}</Text>
        <Text isSecondary className={styles.description}>
          {t('Greta.ProjectsEmptyTextKey')}
        </Text>
      </div>

      <GretaAIChatNameField
        hasCounter
        maxLength={GRETA_PROJECT_NAME_MAX_LENGTH}
        placeholder={t('Greta.ProjectNamePlaceholderKey')}
        qaName={QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_INPUT}
      />

      <div className={styles.actions}>
        <Button.Text
          isGrey
          disabled={isSubmitting}
          height={BUTTON_HEIGHT_32}
          isInline={false}
          qaName={QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_CANCEL}
          text={t('Greta.CancelKey')}
          onClick={onCancel}
        />
        <AIButtonContainedDark
          disabled={isSubmitDisabled}
          height={BUTTON_HEIGHT_32}
          isLoading={isSubmitting}
          qaName={QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_SUBMIT}
          text={t('Greta.NewProjectSubmitKey')}
          type={ButtonType.Submit}
        />
      </div>
    </div>
  )
}

export default GretaAIChatNewProjectForm
